import {
  MAX_PIN_RADIUS,
  PIN_SHADOW_X_RADIUS,
  PIN_SHADOW_Y_OFFSET,
  PIN_SHADOW_Y_RADIUS,
  TILE_SIZE,
} from 'shared/constants/map';

import { fromGlobalPixels } from '../projection';

import { getTilePixelCoords } from './getTilePixelCoords';

type GetExtendedTileBBoxParams = {
  tileNumber: YMaps.TTileNumber;
  zoom: number;
  includeShadow?: boolean;
};

export type ExtendedTileBBox = {
  maxX: number;
  maxY: number;
  minX: number;
  minY: number;
};

/**
 * Расширяет область поиска точек внутри тайла, чтобы корректно отрисовать те пины,
 * что попадают на границы тайлов.
 * @todo: посмотреть на реальных данных, нужна ли эта оптимизация
 */
export function getExtendedTileBBox(params: GetExtendedTileBBoxParams): ExtendedTileBBox {
  const { tileNumber, zoom, includeShadow } = params;

  const [tilePixelCoordX, tilePixelCoordY] = getTilePixelCoords(tileNumber);
  let shadowBottomOffset = 0;
  let shadowSideOffset = 0;

  if (includeShadow) {
    shadowBottomOffset = Math.max(PIN_SHADOW_Y_OFFSET + PIN_SHADOW_Y_RADIUS - MAX_PIN_RADIUS, 0);
    shadowSideOffset = Math.max(PIN_SHADOW_X_RADIUS - MAX_PIN_RADIUS, 0);
  }

  const pixelCoordMinX = tilePixelCoordX - MAX_PIN_RADIUS - shadowSideOffset;
  const pixelCoordMinY = tilePixelCoordY - MAX_PIN_RADIUS;
  const pixelCoordMaxX = tilePixelCoordX + TILE_SIZE + MAX_PIN_RADIUS + shadowSideOffset;
  const pixelCoordMaxY = tilePixelCoordY + TILE_SIZE + MAX_PIN_RADIUS + shadowBottomOffset;

  const [coordMaxX, coordMinY] = fromGlobalPixels([pixelCoordMinX, pixelCoordMinY], zoom);
  const [coordMinX, coordMaxY] = fromGlobalPixels([pixelCoordMaxX, pixelCoordMaxY], zoom);

  return {
    maxX: coordMaxX,
    maxY: coordMaxY,
    minX: coordMinX,
    minY: coordMinY,
  };
}
